import { useCallback } from "react";

import type { UserSessionEventAction } from "@thalamos/aspire-common";

import { api } from "~/api.js";
import { logErrorToDatadog } from "~/tracing.js";

/**
 * Records a product-usage event without blocking the caller. Deliberately returns
 * nothing to await: recording must never delay or fail the interaction it describes.
 */
export function useRecordUserSessionEvent() {
  return useCallback((action: UserSessionEventAction, formDraftId?: string) => {
    void api.userSessionEvents
      .record({ action, formDraftId })
      .catch((error: unknown) => {
        logErrorToDatadog(
          error instanceof Error ? error : new Error(String(error)),
          { action, formDraftId },
        );
      });
  }, []);
}
